export default "__VITE_ASSET__CJJ$6MEh__"